/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Pusher
import Pusher from 'pusher-js'
import VueEcho from 'vue-echo-laravel'

// Enable pusher logging - don't include this in production
Pusher.logToConsole = true

Vue.use(VueEcho, {
  broadcaster: 'pusher',
  key: '1827afcdca8b016d9657',
  cluster: 'mt1',
  forceTLS: true,
  authEndpoint: '/broadcasting/auth',
  auth: {
    headers: {
      // authorization: token ? `Bearer ${token}` : null // Enabled - If you are using Bearer for authentication
    }
  }
})

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js' //temporarily commneted by sajjad

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

import '@/assets/css/custom.css'

// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import { createProvider } from './vue-apollo'

// ACL
import acl from './acl/acl'

import i18n from './i18n'


// Feather font icon
require('./assets/css/iconfont.css')

import {GlobalFunction} from './function'

Vue.prototype.$GlobalFunction = GlobalFunction


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false



Vue.filter('valid_email', function (value) {
  if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
    return ' '
  } else {
    return value
  }
})

Vue.directive("disable-all", {
  // When all the children of the parent component have been updated
  componentUpdated: function(el, binding) {
    const tags = ["input", "button", "select","img"];
    if(binding.value){
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;
        }
      });
    }
    else{
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = false;
          nodes[i].tabIndex = 1;
        }
      });
    }
  
  }
});

new Vue({
  router,
  store,
  acl,
  apolloProvider: createProvider(),
  i18n,
  render: h => h(App)
}).$mount('#app')
